/*
 * @Author: changcheng
 * @LastEditTime: 2023-12-06 16:46:53
 */
import { Empty, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./_index.scss";
import { RootState } from "@root/store";
import { queryRecordLiveNumber } from "@root/common/service";
interface LiveListProps {
  id: number;
  imageAllPath: string;
  playCount: number;
  clickCount: number;
  name: string;
  liveUrl: string;
  startTimeText: string;
}
export default function LiveList(props: {
  data: LiveListProps[];
  type: string;
}) {
  const { data = [], type } = props;
  const { access_token, userDetailInfo } = useSelector(
    (item: RootState) => item.userInfo
  );
  const navigate = useNavigate();
  return (
    <>
      <div className="course_container">
        {data.map((item: LiveListProps, idx: number) => (
          <div
            className="cover_info"
            key={idx}
            onClick={() => {
              if (!access_token) {
                navigate("/login");
              } else {
                window.open(item.liveUrl);
                queryRecordLiveNumber(item.id);
                window.reload();
              }
            }}
          >
            <div className="cover_content">
              <img src={item.imageAllPath} alt="" />
              <h4 className="course_name">{item.name}</h4>
              <div className="video_info">
                <p>直播时间：{item.startTimeText}</p>
                {type !== "preview" && (
                  <p>观看人次：{item.clickCount + item.playCount}次</p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      {data.length === 0 && <Empty />}
    </>
  );
}
LiveList.defaultProps = {
  data: [],
};
